/**
 * Process query snapshot into result data
 * @param {QuerySnapshot} querySnapshot
 * @return {[]}
 */
export const processQuerySnapshot = querySnapshot => {
    let result = []
    querySnapshot.forEach(document => {
        result.push({
            uid: document.id,
            ...document.data(),
        })
    })

    return result
}

/**
 * Process query snapshot into array of id items
 * @param {QuerySnapshot} querySnapshot
 * @return {[]}
 */
export const processQuerySnapshotUid = querySnapshot => {
    let result = []

    querySnapshot.forEach(document => {
        result.push(document.id)
    })

    return result
}
